import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useFireAuth } from './FireAuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './App';

const AdminRoute = () => {
  const { user } = useFireAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user && user.uid) {
        const adminDocRef = doc(db, 'admins', user.uid);
        const adminDocSnap = await getDoc(adminDocRef);
        setIsAdmin(adminDocSnap.exists());
      }
      setIsLoading(false);
    };

    checkAdminStatus();
  }, [user]);

  if (isLoading) {
    return <div></div>;
  }

  if (!isAdmin) {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;